<template>
  <v-app-bar v-if="$device.isDesktop" class="border-b-thin">
    <v-sheet class="d-flex align-center justify-space-between w-100">
      <v-sheet class="d-flex flex-row align-center">
        <LogoDecathlonBrand style="width:32px; height: 32px;" class="mx-4"/>
        <span style="font-family: Decathlon Brand VF,sans-serif; font-size: 24px"
              class="text-uppercase font-weight-bold text-primary">myefficiency</span>
        <span v-if="adminUi" style="font-family: Decathlon Brand VF,sans-serif; font-size: 24px"
              class="text-primary">Admin</span>
        <template v-if="decathlonStore.selectedCrossDiag">
          <v-divider vertical class="mx-4" opacity="100"/>
          <v-chip :text="decathlonStore.selectedCrossDiag.label" size="x-large"
                  class="font-weight-bold text-uppercase pr-1"
                  color="primary" variant="flat" style="font-family: Decathlon Brand VF,sans-serif;">
            <template #append>
              <v-tooltip location="bottom" :text="t('switch-diagnostic')" content-class="bg-grey-darken-4">
                <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" class="v-btn--icon ml-1" size="small"
                         @click="navigateToChooseDiag">
                    <template #default>
                      <v-icon icon="mdi-swap-horizontal-circle" size="40"/>
                    </template>
                  </v-btn>
                </template>
              </v-tooltip>
            </template>
          </v-chip>
          <template v-if="adminUi">
            <v-chip :text="t(decathlonStore.selectedCrossDiag.status.toLowerCase())" prepend-icon="mdi-circle-medium"
                    size="x-large"
                    class="text-subtitle-1 font-weight-bold mx-2"
                    :color="getColorByStatus(decathlonStore.selectedCrossDiag.status)" variant="tonal">
            </v-chip>
            <v-tooltip location="bottom" :text="t('admin.edit-diag')" content-class="bg-grey-darken-4">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon="mdi-cog-outline" size="x-large" density="compact"
                       :to="`/admin/diagnostic/setup`"></v-btn>
              </template>
            </v-tooltip>
          </template>
        </template>
      </v-sheet>
      <Tabs v-if="decathlonStore.selectedCrossDiag && !adminUi"/>
      <v-sheet class="d-flex flex-row align-center">
        <v-btn class="h-100" width="100px" id="choose-store-desktop">
          <template #default>
            <v-sheet class="d-flex flex-column align-center">
              <v-icon size="36" icon="mdi-store-marker-outline"></v-icon>
              <v-sheet v-if="decathlonStore.selectedStore" class="d-flex align-center">
                <CountryFlag size="small" :country="decathlonStore.selectedCountry?.id"/>
                <span class="d-inline-block text-caption text-truncate"
                      style="max-width: 80px">{{
                  useFormattedId(decathlonStore.selectedStore?.id) + ' | ' + useCapitalize(decathlonStore.selectedStore?.name)
                  }}</span>
              </v-sheet>
              <span v-else>--- | -----</span>
            </v-sheet>
          </template>
        </v-btn>
        <v-menu v-model="menuChooseStore" activator="#choose-store-desktop" :location="'bottom center'"
                :close-on-content-click="false">
          <MoleculesChooseStore :admin-ui="adminUi" :close="()=>menuChooseStore=false"/>
        </v-menu>
        <MoleculesDefaultHeaderLanguageSelector v-if="decathlonStore.selectedCrossDiag"
                                                :languages="decathlonStore.selectedCrossDiag?.languages ?? []"/>
        <MoleculesDefaultHeaderUser id="menu-profile-desktop"/>
        <v-btn v-if="adminUi" to="/store" class="h-100" width="100px">
          <template #default>
            <v-sheet class="d-flex flex-column align-center condensed">
              <v-icon size="36" icon="mdi-logout"></v-icon>
              <span class="d-inline-block text-caption text-truncate">{{ t('quit-admin') }}</span>
            </v-sheet>
          </template>
        </v-btn>
        <v-btn v-else-if="userStore.isAdmin" to="/admin/themes" class="h-100" width="100px"
               :disabled="!decathlonStore.selectedCrossDiag">
          <template #default>
            <v-sheet class="d-flex flex-column align-center condensed">
              <v-icon size="36" icon="mdi-cog-outline"></v-icon>
              <span class="d-inline-block text-caption text-truncate">{{
                  t('admin-mode')
                }}</span>
            </v-sheet>
          </template>
        </v-btn>
      </v-sheet>
    </v-sheet>
  </v-app-bar>
  <v-app-bar v-else>
    <v-sheet class="d-flex flex-column w-100 px-2">
      <v-sheet class="d-flex flex-row align-center" min-height="20px">
        <template v-if="decathlonStore.selectedCrossDiag">
          <LogoDecathlonBrand style="width: 16px; height: 16px;" class="mr-1"/>
          <span style="font-family: Decathlon Brand VF,sans-serif; font-size: 12px"
                class="text-uppercase font-weight-bold text-primary">MYEFFICIENCY</span>
        </template>
        <CountryFlag size="small" :country="decathlonStore.selectedCountry?.id" class="ms-auto"/>
        <span v-if="decathlonStore.selectedStore" class="d-inline-block text-caption text-truncate ml-1"
              style="max-width: 200px">{{
            useFormattedId(decathlonStore.selectedStore?.id) + ' | ' + useCapitalize(decathlonStore.selectedStore?.name)
          }}</span>
      </v-sheet>
      <v-sheet v-if="decathlonStore.selectedCrossDiag" class="d-flex flex-row align-center bg-transparent ga-2 mb-1">
        <v-chip size="large"
                class="font-weight-bold text-uppercase pr-0"
                color="primary" variant="flat" style="font-family: Decathlon Brand VF,sans-serif;font-size: 16px">
           <span class="d-inline-block text-truncate" style="max-width: calc(60vw - 45px);">
            {{ decathlonStore.selectedCrossDiag?.label }}
          </span>
          <template #append>
            <v-btn class="v-btn--icon" size="small" @click="navigateToChooseDiag">
              <template #default>
                <v-icon icon="mdi-swap-horizontal-circle" size="36"/>
              </template>
            </v-btn>
          </template>
        </v-chip>
        <v-icon size="32" icon="mdi-home" @click="goHome" color="primary" class="me-auto"/>
        <v-icon size="32" icon="mdi-store-marker-outline" id="choose-store-mobile"></v-icon>
        <v-menu v-model="menuChooseStore" activator="#choose-store-mobile" :location="'bottom center'"
                :close-on-content-click="false">
          <MoleculesChooseStore :admin-ui="adminUi" :close="()=>menuChooseStore=false"/>
        </v-menu>
        <v-icon size="32 " icon="mdi-dots-vertical" id="dots-vertical-menu-activator-mobile"></v-icon>
        <v-menu activator="#dots-vertical-menu-activator-mobile">
          <v-list density="compact">
            <MoleculesDefaultHeaderLanguageSelector :languages="decathlonStore.selectedCrossDiag?.languages ?? []"/>
            <v-divider></v-divider>
            <MoleculesDefaultHeaderUser id="menu-profile-mobile"/>
          </v-list>
        </v-menu>
      </v-sheet>
      <v-sheet class="d-flex flex-row align-center" v-else>
        <LogoDecathlonBrand style="width:32px; height: 32px;" class="mx-1"/>
        <span style="font-family: Decathlon Brand VF,sans-serif; font-size: 24px"
              class="text-uppercase font-weight-bold text-primary me-auto">MYEFFICIENCY</span>
        <v-icon size="32" icon="mdi-store-marker-outline" id="choose-store-welcome"></v-icon>
        <v-menu v-model="menuChooseStore" activator="#choose-store-welcome" :location="'bottom center'"
                :close-on-content-click="false">
          <MoleculesChooseStore :admin-ui="adminUi" :close="()=>menuChooseStore=false"/>
        </v-menu>
        <v-icon size="32 " icon="mdi-dots-vertical" id="dots-vertical-menu-activator-welcome"></v-icon>
        <v-menu activator="#dots-vertical-menu-activator-welcome">
          <v-list density="compact">
            <MoleculesDefaultHeaderUser id="menu-profile-welcome"/>
          </v-list>
        </v-menu>
      </v-sheet>
    </v-sheet>
  </v-app-bar>
</template>

<script lang="ts" setup>
import {useI18n} from "vue-i18n";
import Tabs from "~/components/molecules/default-header/Tabs.vue";
import LogoDecathlonBrand from "@vtmn-play/assets/svg/logo-decathlon-core-symbol-brand.svg";


const {t} = useI18n()
const decathlonStore = useDecathlonStores()
const diagnosticStores = useDiagnosticStore()
const languageStore = useLanguageStore()
const userStore = useUserStore()

const {adminUi} = defineProps<{
  adminUi: boolean
}>()

useAsyncData(async () => {
  decathlonStore.fetchSelectedCrossDiag()
  decathlonStore.fetchCountries()
  diagnosticStores.fetchDiagnosticByStore()
})

const menuChooseStore = ref(!decathlonStore.selectedStore)
const goHome = async () => {
  await navigateTo(`/store`)
}

const navigateToChooseDiag = async () => await
    navigateTo((adminUi ? `/admin` : ``) + `/choose-diag`)


</script>
<i18n lang="yaml">
fr:
  primary-diag: Diag prioritaire
  custom-diag: Diag sur-mesure
  alert-diag: Diag KPI
  region: Ma région
  action-plan: "Actions"
  choose-theme: Séléctionne un thème
  choose-diagnostic: Séléctionne un diagnostic
en:
  primary-diag: Primary diagnosis
  custom-diag: Custom diagnosis
  alert-diag: KPI diagnosis
  region: My region
  action-plan: Actions
  choose-theme: Choose a theme
  choose-diagnostic: Choose a diagnostic
</i18n>
